<template>
    <v-carousel :height="imageHeight" hide-controls delimiter-icon="stop">
        <v-carousel-item
                v-for="(item, i) in items"
                :key="i"
                :src="item.src"
        ></v-carousel-item>
    </v-carousel>
</template>

<script>
    import {isMobile} from 'mobile-device-detect';

    export default {
        name: "Carousel",
        data() {
            let carousel = isMobile ? "carousel" : "carouselBig";
            return {
                items: [
                    {
                        src: require("../assets/" + carousel + "/cyber-security-cybersecurity-device-60504.jpg")
                    },
                    {
                        src: require("../assets/" + carousel + "/pcprog.jpg")
                    },
                    {
                        src: require("../assets/" + carousel + "/sticky-note-to-ship-code.jpg")
                    },
                    {
                        src: require("../assets/" + carousel + "/write-notes-from-laptop.jpg")
                    }
                ]
            };
        },
        computed: {
            imageHeight() {
                switch (this.$vuetify.breakpoint.name) {
                    case "xs":
                        return "300px";
                    case "sm":
                        return "300px";
                    case "md":
                        return "600px";
                    case "lg":
                        return "600px";
                    case "xl":
                        return "600px";
                }
            }
        }
    };
</script>
